// src/components/pages/VenueSection.jsx
import React, { useEffect, useState } from 'react';
import axios from '../../utils/axiosConfig';
import GalleryCarousel from './GalleryCarrusel';

export default function VenueSection({ slug, cliente, isAdmin }) {
  const [images, setImages] = useState([]);
  const [deleteMode] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [msg, setMsg] = useState('');

  useEffect(() => { fetchVenue(); }, [slug]);
  async function fetchVenue() {
    try {
      // ✅ Pedimos las fotos del salón
      const { data } = await axios.get(`/${slug}/api/images`, { params: { category: 'venue' } });
      setImages(data.images || []);
    } catch {
      setImages([]);
    }
  }

  async function handleDelete(id) {
    try {
      setDeletingId(id);
      await axios.delete(`/${slug}/api/images/${id}`, { withCredentials: true });
      setMsg('Imagen eliminada.');
      fetchVenue();
    } catch {
      setMsg('Error al eliminar.');
    } finally {
      setDeletingId(null);
      setTimeout(() => setMsg(''), 1800);
    }
  }

  // 👇 Si no hay imágenes y el usuario NO es admin, ocultamos la sección completa
  if (!isAdmin && images.length === 0) return null;

  return (
    <section className="mt-10 md:mt-16 mb-10 md:mb-12 relative">
      <div className="flex items-center justify-center gap-3 mb-6 md:mb-8">
        <h2 className="text-3xl md:text-4xl font-black text-white text-center tracking-tight leading-tight">Fotos de Nuestras Instalaciones</h2>

      </div>

      {msg && <p className="text-center text-green-600 mb-4">{msg}</p>}

      {images.length === 0 ? (
        // Estado vacío: sólo lo ve el admin para que pueda subir algo
        isAdmin ? (
          <div className="text-center text-white/40 bg-surface p-8 rounded-2xl border border-dashed border-white/10">
            No hay imágenes del espacio aún.
            <button
              onClick={() => window.location.href = `/${cliente.slug}/admin/gallery?type=venue`}
              className="ml-2 text-primary-orange hover:text-accent font-bold underline transition-colors"
            >
              Subí la primera
            </button>
          </div>
        ) : null
      ) : (
        <GalleryCarousel
          images={images}
          deleteMode={deleteMode}
          deletingId={deletingId}
          onDelete={handleDelete}
          isAdmin={isAdmin}
          autoPlay
          autoPlayMs={3000}
          fit="contain"
          bgClass="bg-slate-900"
        />
      )}

      {/* Si usás modal de zoom, podés reusar el que ya tenés en Home */}
    </section>
  );
}
